const MOBILE_USER_AGENT =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|Mobile/i;

const getNavigator = () =>
  typeof globalThis.navigator === "undefined" ? undefined : globalThis.navigator;

// UA Client Hints is the strongest signal when available. The user-agent
// fallback covers Safari and older browsers; the final check handles iPadOS
// when it requests a desktop-class user agent.
export function isMobileDevice(client = getNavigator()) {
  if (!client) return false;
  if (client.userAgentData?.mobile === true) return true;

  const userAgent = client.userAgent || client.vendor || "";
  if (MOBILE_USER_AGENT.test(userAgent)) return true;

  return (
    /MacIntel/i.test(client.platform || "") &&
    Number(client.maxTouchPoints || 0) > 1
  );
}

class MobileDetectUtil {
  static judgeClient(client = getNavigator()) {
    const userAgent = client?.userAgent || client?.vendor || "";

    if (/android/i.test(userAgent)) return "Android";
    if (/iPad|iPhone|iPod/i.test(userAgent)) return "iOS";
    if (/windows phone|IEMobile/i.test(userAgent)) return "Windows Phone";
    if (isMobileDevice(client)) return "Mobile";
    return "Desktop";
  }
}

export default MobileDetectUtil;
